import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { StaffShell } from '@/shells/StaffShell';

export const Route = createFileRoute('/_staff')({
  beforeLoad: ({ context }) => {
    if (!context.auth.me?.is_staff) throw redirect({ to: '/' });
  },
  component: () => (
    <StaffShell>
      <Outlet />
    </StaffShell>
  ),
});
